// extracted by mini-css-extract-plugin
module.exports = {"containerResults":"styles-module--containerResults--28mD2","containerFeedback":"styles-module--containerFeedback--WX_Uo","display":"styles-module--display--3jTho"};